import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { path: '/', label: 'Início' },
    { path: '/como-trabalho', label: 'Como Trabalho' },
    { path: '/acompanhamentos', label: 'Acompanhamentos' },
    { path: '/processo', label: 'Processo' },
    { path: '/contacto', label: 'Conversa' },
    { path: '/sobre', label: 'Sobre' },
  ];

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <>
      <header className="site-header" data-testid="site-header">
        <div className="header-inner">
          <Link 
            to="/" 
            className="font-serif text-xl text-[#1A1A1A] hover:opacity-70 transition-opacity"
            data-testid="logo-link"
          >
            Rafael Pinto
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8" data-testid="desktop-nav">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`nav-link ${isActive(item.path) ? 'active' : ''}`}
                data-testid={`nav-link-${item.path.replace('/', '') || 'home'}`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 text-[#1A1A1A]"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
            data-testid="mobile-menu-toggle"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </header>

      {/* Mobile Menu */}
      <div 
        className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}
        data-testid="mobile-menu"
      >
        <button
          className="absolute top-6 right-6 p-2 text-[#1A1A1A]"
          onClick={() => setMobileMenuOpen(false)}
          aria-label="Close menu"
          data-testid="close-mobile-menu"
        >
          <X size={24} />
        </button>
        
        {navItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className="mobile-nav-link"
            onClick={() => setMobileMenuOpen(false)}
            data-testid={`mobile-nav-link-${item.path.replace('/', '') || 'home'}`}
          >
            {item.label}
          </Link>
        ))}
      </div>
    </>
  );
};
